<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'AlimentoApp',
}

</script>



// WEBPACK FOOTER //
// src/components/alimentoapp/Alimento.vue